import React, { useEffect, useState } from "react";

const COMMIT_PATTERN = /^[0-9a-f]{7,40}$/i;

const Footer: React.FC = () => {
  const [commit, setCommit] = useState<string>();

  useEffect(() => {
    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(), 3_000);
    void fetch("/api/health", { cache: "no-store", signal: controller.signal })
      .then(async (response) => {
        if (!response.ok) return;
        const payload = await response.json();
        const value = payload?.deployment?.commit;
        if (typeof value === "string" && COMMIT_PATTERN.test(value)) setCommit(value);
      })
      .catch(() => undefined)
      .finally(() => window.clearTimeout(timer));
    return () => {
      window.clearTimeout(timer);
      controller.abort();
    };
  }, []);

  return (
    <footer className="tsm-footer">
      <nav className="tsm-footer-links">
        <a href="https://james.tyl.ee" target="_blank" rel="noreferrer noopener">About James Tylee</a>
        <a href="/legal/privacy.html">Privacy Policy</a>
        <a href="/legal/tos.html">Terms of Service</a>
        <a href="/legal/cookies.html">Cookie Policy</a>
        <a href="/legal/gdpr.html">GDPR</a>
        <a href="/legal/us-privacy.html">US Privacy</a>
        <a href="/legal/legal.html">Legal Disclaimer</a>
        <a href="/legal/esg.html">ESG</a>
      </nav>
      <nav className="tsm-footer-links" aria-label="Product docs">
        <a href="/product.md">Product</a>
        <a href="/brief.md">Brief</a>
        <a href="/analytics.md">Analytics</a>
        <a href="/monitor.md">Monitor</a>
        <a href="/get-started.md">Get Started</a>
        <a href="/llms.txt">LLMs</a>
        <a href="https://github.com/hottweelz/Tylee-Smart-Markets" target="_blank" rel="noreferrer noopener">Docs on GitHub</a>
      </nav>
      <div className="tsm-footer-copy">
        <p>© 2026 Tylee Smart Markets · Not financial advice · All rights reserved.</p>
        {commit && <p><a href="/status" title={`Deployed commit ${commit}`}>Build {commit.slice(0, 7)} · System Status</a></p>}
      </div>
    </footer>
  );
};

export default Footer;
